
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import FigablLogo from '@/components/FigablLogo';

const Header = () => {
  const { user, signOut } = useAuth();

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <FigablLogo className="h-8 w-auto mr-2 text-black" />
        </Link>
        
      </div>
    </header>
  );
};

export default Header;
